import PlacementsSingle from './PlacementsSingle'
import PlacementsList from './PlacementsList'
import PlacementsStartComponent from './PlacementsStartComponent'
import PlacementsStartComponentPerformance from './PlacementsStartComponentPerformance'
import PlacementsStartComponentReview from './PlacementsStartComponentReview'
import PlacementsStartComponentDevelopment from './PlacementsStartComponentDevelopment'
import PlacementsStartComponentDevelopmentGraduate from './PlacementsStartComponentDevelopmentGraduate'
import PlacementsEndComponent from './PlacementsEndComponent'
import PlacementsEndComponentReview from './PlacementsEndComponentReview'
import PlacementsEndComponentReviewManager from './PlacementsEndComponentReviewManager'
import PlacementsEndComponentReviewGraduateComments from './PlacementsEndComponentReviewGraduateComments'
import PlacementsEndComponentPerformance from './PlacementsEndComponentPerformance'
import PlacementsEndComponentCapabilities from './PlacementsEndComponentCapabilities'
import PlacementsEndComponentOverall from './PlacementsEndComponentOverall'
import PlacementsStartComponentReviewComments from './PlacementsStartComponentReviewComments'
import PlacementsStartComponentPerformanceAdmin from './PlacementsStartComponentPerformanceAdmin'
import PlacementsStartComponentDevelopmentAdmin from './PlacementsStartComponentDevelopmentAdmin'
import PlacementsStartComponentReviewAdmin from './PlacementsStartComponentReviewAdmin'
import PlacementsEndComponentReviewGraduateCommentsAdmin from './PlacementsEndComponentReviewGraduateCommentsAdmin'
import PlacementsEndComponentReviewAdmin from './PlacementsEndComponentReviewAdmin'

export default {
  PlacementsSingle,
  PlacementsList,
  PlacementsStartComponent,
  PlacementsStartComponentPerformance,
  PlacementsStartComponentReview,
  PlacementsStartComponentDevelopment,
  PlacementsStartComponentDevelopmentGraduate,
  PlacementsEndComponent,
  PlacementsEndComponentReview,
  PlacementsEndComponentReviewGraduateComments,
  PlacementsEndComponentPerformance,
  PlacementsEndComponentCapabilities,
  PlacementsEndComponentOverall,
  PlacementsEndComponentReviewManager,
  PlacementsStartComponentReviewComments,
  PlacementsStartComponentPerformanceAdmin,
  PlacementsStartComponentDevelopmentAdmin,
  PlacementsStartComponentReviewAdmin,
  PlacementsEndComponentReviewGraduateCommentsAdmin,
  PlacementsEndComponentReviewAdmin
}
